  let trcFitmentRunning = false;

  document.addEventListener("click", function(e) {
    const btn = e.target.closest(".trc-h__cta");
    if (!btn) return;

    e.preventDefault();

    if (trcFitmentRunning) return;
    trcFitmentRunning = true;

    const target = document.getElementById("fitment_target");
    if (!target) { 
      trcFitmentRunning = false; 
      return; 
    }

    // --- SCROLL ---
    const offset = 300;
    const topPos =
      target.getBoundingClientRect().top +
      window.pageYOffset -
      offset;

    window.scrollTo({
      top: topPos,
      behavior: "smooth"
    });

    setTimeout(() => {

      const another = target.querySelector(".fit__another");
      if (another) another.click();

      setTimeout(() => {
        const back1 = document.getElementById("vs-back-global");
        if (back1) back1.click();

        setTimeout(() => {
          const back2 = document.getElementById("vs-back-global");
          if (back2) back2.click();

          const trigger = document.getElementById("vs-trigger");
          if (trigger?.getAttribute("aria-expanded") === "false") {
            trigger.click();
          }

          trcFitmentRunning = false;

        }, 10);

      }, 10);

    }, 10);

  });

